import GroupsModule from './GroupsModule'
export default GroupsModule
